// extracted by mini-css-extract-plugin
export default {"emojis":"videomeetchat_emojis__NGXgn","forimages":"videomeetchat_forimages__jyH11","hoverzoomicon":"videomeetchat_hoverzoomicon__eo25m"};